import React from "react"
import { getCaseStateIcon } from "../../commonFunctions/commonFunctions";
import { useTranslation } from "react-i18next";

function CaseStateSummaryItem(props){
    const { t } = useTranslation();
    const {stateName, stateId, count} = props;

    return(
        <div style={{display: "flex", alignItems: "center", columnGap: "0.5rem"}}>
            <div>{<img width={24} src={getCaseStateIcon(stateId)}/>}</div>
            <div>
                <div style={{fontSize: "0.75rem"}}>{stateName}</div>
                <div style={{fontWeight: 700}}>{count === 1 ? `${count} ${t("Case").toLowerCase()}` : `${count} ${t("Cases").toLowerCase()}`}</div>
            </div>
        </div>
    )
}

export {CaseStateSummaryItem}